import { useMemo } from 'react';
import type { ChatUiFlightOffer } from '@voll-intelligence/genui-contract';
import { FlightPolicyDrawer as KitFlightPolicyDrawer } from '@voll-intelligence/intelligence-ui-kit';
import { flightPolicyCopy } from '../../../../shared/ui/flight_offer_copy.js';
import { useGenUiI18n } from '../../../../shared/ui/i18n.js';

/** A gaveta "Detalhes da Política" do kit (#4997) com os textos do catálogo.
 *  Sai quando a lista de ofertas mudar para o kit. */
export function FlightPolicyDrawer({
  offer,
  onClose,
}: {
  readonly offer: ChatUiFlightOffer;
  readonly onClose: () => void;
}) {
  const { locale } = useGenUiI18n();
  const copy = useMemo(() => flightPolicyCopy(locale), [locale]);
  return <KitFlightPolicyDrawer offer={offer} onClose={onClose} copy={copy} locale={locale} />;
}
